import React, { useMemo } from 'react';
import GPT from '@op/components/GPT';
import { GptOptionsType } from '@op/components/GPT/types';
import { Button } from 'tea-component';
import useFullDialog from '@op/components/GPT/hooks/useFullDialog';
import useLanguage from '@op/hooks/useLanguage';
import './index.scss';

export default function GPTType(props: any) {
  const { onChange, value, defaultValue } = props;
  const { promptInfo, prompt, task_type } = defaultValue || {};
  const { formatMessage } = useLanguage();
  const BasicNear = ({
    toggleVisible,
    formatMessage,
  }: {
    toggleVisible: any;
    formatMessage: any;
  }) => (
    <Button
      type="link"
      onClick={() => {
        toggleVisible();
      }}
      style={{ marginLeft: '8px' }}
    >
      {formatMessage({ id: 'Prompt' })}
    </Button>
  );


  const { type, promptText } = useMemo(() => {
    const type = promptInfo?.gptOptions || task_type;
    const promptText = promptInfo?.prompt || prompt;

    return { type, promptText };
  }, [promptInfo, prompt]);


  const renderHtml = useMemo(() => {
    if (!promptText) return null;

    return promptText
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\n/g, '<br/>');
  }, [promptText]);



  const { FullDialog, openFullDialog } = useFullDialog({
    renderHtml,
    summary: promptText,
    hideSubTitle: true,
    className: 'dbo-gpt-type-full-dialog',
  });

  return (
    <div className="dbo-gpt-type-wrapper">
      <GPT.GPTOptions
        remainder={-1}
        total={0}
        shortText={false}
        gptOptions={(type) as GptOptionsType}
        setGptOptions={(val) => {
          // buriedBtnPoint('GPT_Options', gptType, value, val);
          // setPromptInfo({ gptOptions: val }, value);
        }}
        basicNearElement={
          <BasicNear
            toggleVisible={openFullDialog}
            formatMessage={formatMessage}
          ></BasicNear>
        }
      />
      <FullDialog />
    </div>
  );
}
